/* eslint-disable */
import React, { useState } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { CheckCheck } from 'lucide-react';
import { Navbar, Sidebar } from '../../components';
import NotificationRow from '../../components/notifications/NotificationRow';
import useNotifications from '../../components/notifications/useNotifications';
import '../../components/notifications/notifications.css';
import './notificationCenter.css';

const TABS = [
  { key: 'all', label: 'All' },
  { key: 'action', label: 'Needs action' },
  { key: 'pto', label: 'Time off' },
  { key: 'profile', label: 'Profile updates' },
  { key: 'ack', label: 'Acknowledgements' },
];

const matches = (item, tab) => {
  if (tab === 'action') return item.status === 'pending' && item.actionable;
  if (tab === 'pto') return item.category === 'pto';
  if (tab === 'profile') return item.category === 'profile';
  if (tab === 'ack') return item.category === 'ack';
  return true;
};

const RANGES = [
  { value: '', label: 'All time' },
  { value: 'today', label: 'Today' },
  { value: '7', label: 'Last 7 days' },
  { value: '30', label: 'Last 30 days' },
  { value: '90', label: 'Last 90 days' },
];
const ageOf = (item) => {
  if (Number.isFinite(item.ageDays)) return item.ageDays;
  const t = String(item.time || '');
  if (/yesterday/i.test(t)) return 1;
  const d = t.match(/(\d+)\s*day/i);
  if (d) return Number(d[1]);
  return 0; // minutes / hours / just now
};
const withinRange = (item, range) => {
  if (!range) return true;
  const age = ageOf(item);
  if (range === 'today') return age < 1;
  return age <= Number(range);
};

export default function NotificationCenter() {
  const {
    items, loading, unreadCount, busyIds, approve, reject, markAllRead, nextCursor, loadMore,
  } = useNotifications();
  const [tab, setTab] = useState('all');
  const [range, setRange] = useState('');

  const actionCount = items.filter((i) => i.status === 'pending' && i.actionable).length;
  const filtered = items.filter((i) => matches(i, tab) && withinRange(i, range));

  return (
    <div>
      <Navbar />
      <Sidebar />
      <div className="screen-wrapper">
        <div className="screen-header" style={{ fontFamily: 'Inter, sans-serif' }}>
          <div className="nc-head">
            <div>
              <h1 className="nc-title">Notifications</h1>
              <p className="nc-sub">Approvals and updates across your workspace</p>
            </div>
            <div className="nc-head-actions">
              <select
                className="nc-range"
                value={range}
                onChange={(e) => setRange(e.target.value)}
                aria-label="Date range"
              >
                {RANGES.map((r) => <option key={r.value} value={r.value}>{r.label}</option>)}
              </select>
              <button
                type="button"
                className="shoot-notif-markall nc-markall"
                onClick={markAllRead}
                disabled={!unreadCount}
              >
                <CheckCheck size={15} strokeWidth={2} />
                Mark all as read
              </button>
            </div>
          </div>

          <div className="nc-tabs">
            {TABS.map((t) => (
              <button
                key={t.key}
                type="button"
                className={`nc-tab${tab === t.key ? ' on' : ''}`}
                onClick={() => setTab(t.key)}
              >
                {t.label}
                {t.key === 'action' && actionCount ? <span className="nc-tabcount">{actionCount}</span> : null}
              </button>
            ))}
          </div>

          <div className="nc-card">
            {loading ? (
              <div className="shoot-notif-empty"><p>Loading…</p></div>
            ) : !filtered.length ? (
              <div className="shoot-notif-empty">
                <p>Nothing here</p>
                <span className="sub">You&apos;re all caught up.</span>
              </div>
            ) : (
              filtered.map((item) => (
                <NotificationRow
                  key={item.id}
                  item={item}
                  busy={Boolean(busyIds[item.id])}
                  onApprove={approve}
                  onReject={reject}
                />
              ))
            )}
          </div>

          {/*
            The list is keyset paginated rather than fetched whole: the feed only grows,
            and a long-serving member's history is not something to load into a popover.
          */}
          {nextCursor && !loading ? (
            <div className="nc-more">
              <button type="button" className="shoot-notif-markall" onClick={loadMore}>
                Load older notifications
              </button>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}
